export default Object.freeze({
  //이용약관
  MERCHANT_CENTER_TITLE: '구글 머천트센터 서비스 이용약관',
  ADVERTISING_PROGRAM_TITLE: '구글 광고 프로그램 서비스 이용약관',
  THIRD_PARTY_PROVISION_OF_PERSONAL_INFORMATION_TITLE: '개인정보 제3자 제공 동의',
});
